import { render } from "./Taiyo.vue?vue&type=template&id=26a69c12&scoped=true"
import script from "./Taiyo.vue?vue&type=script&lang=js"
export * from "./Taiyo.vue?vue&type=script&lang=js"

import "./Taiyo.vue?vue&type=style&index=0&id=26a69c12&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26a69c12"]])

export default __exports__